// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"a206d690","560":"a656ce51"}[chunkId] + ".chunk.css";
};